import type { ReactNode } from 'react';

/**
 * Liga/desliga com efeito imediato (ex.: dados ficticios). O rotulo faz parte do
 * botao, entao tocar no texto tambem troca — alvo grande para o polegar.
 */
export function Interruptor({
  ligado,
  onMudar,
  children,
  noMenu = false,
  naLateral = false,
}: {
  ligado: boolean;
  onMudar: (ligado: boolean) => void;
  children: ReactNode;
  /** Dentro de um `Menu`: vira item de menu marcavel, com a largura toda. */
  noMenu?: boolean;
  /** Sobre a barra lateral escura: trilho e texto nas cores dela. */
  naLateral?: boolean;
}) {
  return (
    <button
      type="button"
      role={noMenu ? 'menuitemcheckbox' : 'switch'}
      aria-checked={ligado}
      onClick={() => onMudar(!ligado)}
      className={`inline-flex min-h-9 items-center gap-2.5 text-sm font-medium ${naLateral ? 'text-sobre-lateral' : 'text-texto'} ${
        noMenu ? 'w-full px-3 hover:bg-destaque-fundo' : ''
      }`}
    >
      <span
        aria-hidden
        className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border transition-colors ${
          naLateral
            ? ligado
              ? 'border-nevoa bg-nevoa'
              : 'border-lateral-apagado/60 bg-transparent'
            : ligado
              ? 'border-marca bg-marca'
              : 'border-borda-forte bg-superficie-2'
        }`}
      >
        <span
          className={`absolute size-3.5 rounded-full transition-[left] ${
            ligado
              ? `left-4.5 ${naLateral ? 'bg-abismo' : 'bg-sobre-marca'}`
              : `left-0.5 ${naLateral ? 'bg-lateral-apagado' : 'bg-apagado'}`
          }`}
        />
      </span>
      {children}
    </button>
  );
}
